/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetHouseOfferHistorySpoilerRequest,
  TGetHouseOfferHistorySpoilerModel,
  IMappers,
  TGetHouseOfferHistorySpoilerResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IOfferHistorySpoilerResponseV1 } from '../../entities/offer_history/OfferHistorySpoilerResponseV1';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetHouseOfferHistorySpoilerModel(
  parameters: TGetHouseOfferHistorySpoilerRequest,
): TGetHouseOfferHistorySpoilerModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v2/get-house-offer-history-spoiler/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetHouseOfferHistorySpoilerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetHouseOfferHistorySpoilerRequest;
}

export async function fetchGetHouseOfferHistorySpoiler<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHouseOfferHistorySpoilerOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetHouseOfferHistorySpoilerResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetHouseOfferHistorySpoilerModel(parameters),
    config,
  )) as FetchResponse<TGetHouseOfferHistorySpoilerResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IOfferHistorySpoilerResponseV1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetHouseOfferHistorySpoilerResponse>;
}
